export default "__VITE_ASSET__BrsCFpT8__"